/* eslint-disable react/jsx-max-props-per-line */
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import TopUpCard from 'components/Common/TopUpCard';
import RemindDashboard from './RemindDashboard';
import TutorialDashboard from './TutorialDashboard';
import Styles from './index.module.css';

function OrangeButton({
  onClick,
  children,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={Styles.orangeButton}
    >
      {children}
    </button>
  );
}

OrangeButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
};

OrangeButton.defaultProps = {
  onClick: () => {},
  children: null,
};

function TopUp() {
  return (
    <div
      className={Styles.container}
    >
      <div
        className={Styles.leftBoard}
      />
      <div
        className={Styles.midBoard}
      >

        <div
          className={Styles.midBoardItem}
        >
          <div
            className={Styles.titleText}
          >
            儲值狀態
          </div>
          <TopUpCard />
        </div>
        <div
          className={Styles.midBoardItem}
        >
          <div
            className={Styles.titleText}
          >
            欣新網貼心提醒
          </div>
          <RemindDashboard />
        </div>
        <div
          className={Styles.midBoardItem}
        >
          <div
            className={Styles.titleText}
          >
            儲值教學
          </div>
          <TutorialDashboard />
        </div>
        <a
          href="https://www.hhgalaxy.com.tw/qa/88#1" rel="noopener noreferrer nofollow" target="_blank"
          className={Styles.midBoardButton}
        >
          <OrangeButton>查看儲值教學</OrangeButton>
        </a>
      </div>
      <div className={Styles.rightBoard} />
    </div>
  );
}

export default memo(TopUp);
